<template>
  <v-menu
    v-model="datepicker"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        dense
        filled
        flat
        :id="id"
        :placeholder="placeholder"
        hide-details
        solo
        :disabled="disabled"
        prepend-inner-icon="mdi-calendar"
        readonly
        :rules="rules"
        v-bind="attrs"
        v-on="on"
        :value="formattedDate"
        color="cyan"
        :class="className"
      ></v-text-field>
    </template>
<!-- :allowed-dates="allowedDates" -->
    <v-date-picker
      v-model="date"
      color="cyan"
      :min="minDate"
      :max="maxDate"
      no-title
      :first-day-of-week="weekday"
      :disabled="disabled"
      v-on:input="datepicker = false"
      v-on:change="emitValue()"
       
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters } from "vuex";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "datepicker",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    id: {
      type: String,
      default: "start-date",
    },
    placeholder: {
      type: String,
      default: "Start Date",
    },
    minDate: {
      type: String,
      default: null,
    },
    maxDate: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    rules: {
      type: Array,
      default: () => {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: "",
    },
  },
  watch: {
    value: function () {
      this.init();
    },
  },
  data() {
    return {
      datepicker: false,
      date: null,
    };
  },
  methods: {
    allowedDates(date) {
  // Disable Sundays only
  return moment(date).day() !== 0;
},
    init() {
      this.date = this.value;
    },

    emitValue() {
      this.$emit("input", this.date);
      this.$emit("change", this.date);
    },
    getAppConfig() {
      const _this = this;
      if (_this.localConfigDBLoading) {
        return false;
      }

      _this.$store
        .dispatch("setLocalConfig")
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  mounted() {
    this.init();
    this.getAppConfig();
  },
  computed: {
    ...mapGetters(["localConfigDB", "localConfigDBLoading"]),
    dateFormat() {
      return this.localConfigDB?.date_format ?? "DD/MM/YYYY";
    },
    dateTimeFormat() {
      return this.dateTimeFormat + " " + this.timeFormat;
    },
    timeFormat() {
      return this.localConfigDB?.time_format ?? "HH:mm";
    },
    formattedDate() {
      if (this.date) {
        return moment(this.date).format(this.dateFormat);
      }
      return this.date;
    },
    weekday() {
      const config = this.localConfigDB;
      return config && config.weekday == 1 ? 0 : 1;
    },
  },
};
</script>
